import api from '../index'

export default {
  // 登录
  login: (data: {
    username: string
    password: string
    device_token: string
  }) => api.post('login', data),

  // 登出
  logout: () => api.post('logout'),

  // 获取当前用户信息
  me: () => api.get('me'),

  // 刷新token
  refresh: () => api.post('refresh'),

  // 修改密码
  changePassword: (data: {
    old_password: string
    password: string
  }) => api.post('user/change-password', data),

  // Facebook广告账户授权相关
  facebook: {
    // 生成Facebook授权URL
    generateAuthUrl: () => api.post('/market/facebook/auth/generate-url'),
    // 处理授权回调
    handleAuthCallback: (params: any) => api.get('/market/facebook/auth/callback', { params }),
    // 获取Facebook负责人列表
    getOwnersList: () => api.get('/market/facebook/get-operation-users'),
    // 根据广告ID获取对应详情
    getAdvertiserDetail: (id: number) => api.get(`/market/facebook/ad-account/${id}/details`),
    // 批量更新/新增Facebook广告账号使用人
    batchAssignOwner: (params: any) => api.post('/market/facebook/ad-account/update-usage-records', params),
    // 删除使用者记录
    deleteOwnerRecord: (id: any) => api.delete(`/market/facebook/ad-account/usage-record/${id}`),
    // 确认授权
    confirmAuth: (params: any) => api.post('/market/facebook/auth/confirm', params),
  },

  // TikTok广告账户授权相关
  tiktok: {
    // 生成TikTok授权URL
    generateAuthUrl: () => api.post('/market/tiktok/auth/generate-url'),
    // 处理授权回调
    handleAuthCallback: (params: any) => api.get('/market/tiktok/auth/callback', { params }),
    // 获取TikTok负责人列表
    getOwnersList: () => api.get('/market/tiktok/owners'),
    // 分配TikTok广告账户负责人
    assignOwner: (params: any) => api.post('/market/tiktok/tk-advertiser/assign-owner', params),
    // 获取TikTok广告账户列表
    getAdAccountList: (recordId: number) => api.get(`/market/tiktok/auth/advertiser/${recordId}`),
    // 批量分配TikTok广告主负责人
    batchAssignOwner: (params: any) => api.post('/market/tiktok/tk-advertiser/assign-owner', params),
    // 删除使用者记录
    deleteOwnerRecord: (id: any) => api.delete(`/market/tiktok/tk-advertiser/record/${id}`),
    // 批量取消TikTok广告主授权
    batchRevokeAuth: (params: any) => api.post('/market/tiktok/tk-advertiser/revoke', params),
    // 根据广告主ID获取对应详情
    getAdvertiserDetail: (id: number) => api.get(`/market/tiktok/tk-advertiser/detail/${id}`),
    // 确认广告主配置
    confirmOwnerConfig: (params: any) => api.post('/market/tiktok/auth/init-advertiser-data', params),
    // 根据广告主ID同步成效数据
    syncInsightData: (params: any) => api.post('/market/tiktok/tk-advertiser/sync-insights', params),
  },

  // bigo广告账户授权相关
  bigo: {
    // 根据广告ID获取对应详情
    getAdvertiserDetail: (params: any) => api.get('/market/bigo/list-ad-detail', { params }),
    // 批量更新/新增Facebook广告账号使用人
    batchAssignOwner: (params: any) => api.post('/market/bigo/update-owner', params),
    // 获取TikTok负责人列表
    getOwnersList: () => api.get('/market/bigo/owners'),
    // 删除使用者记录
    deleteOwnerRecord: (params: any) => api.delete('/market/bigo/delete-usage-record', { params }),
  },
}
